import React, { useState } from 'react'

import Modal from '../shared/Modal'
import SubmitButton from '../shared/SubmitButton'
import Button from '../shared/Button'
import Input from '../shared/Input'

interface NotSentConfirmationProps {
  handleClose: () => void
  handleSubmit: (type: string, verificationInput: string) => void
  companyColor: string
  setOrderSent: (orderSent: boolean) => void
}

const NotSentConfirmation: React.FC<NotSentConfirmationProps> = ({ handleClose, handleSubmit, companyColor, setOrderSent }: NotSentConfirmationProps) => {
  const [tab, setTab] = useState('mail')
  const [verificationInput, setVerificationInput] = useState('')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (tab === 'phone') {
      if (e.target.value.length === 0) {
        setVerificationInput('')
        return
      }
      if (!/^[0-9+]+$/.test(e.target.value) || e.target.value.length > 12) {
        return
      }
    }
    setVerificationInput(e.target.value)
  }

  return (
    <Modal
      show title="Reenviar Orden"
      description="Puedes recibir tu orden de venta de dos formas distintas"
    >
      <div className='flex justify-center w-full mt-8 md:text-lg text-base'>
        <button className={`${tab === 'mail' ? 'font-bold border-b-2 border-black text-black' : 'border-b border-gray-500 text-gray-500'} w-1/2 font-['Inter']`} type="button" onClick={() => setTab('mail')}>Mail </button>
        <button className={`${tab === 'phone' ? 'border-b-2 font-bold border-black text-black' : 'border-b border-gray-500 text-gray-500'} w-1/2 font-['Inter']`} type="button" onClick={() => setTab('phone')}>Teléfono </button>
      </div>

      <form onSubmit={(e) => {e.preventDefault(); handleSubmit(tab, verificationInput) }}>
        <div className='md:mb-6 mb-6 mt-2 h-14'>
          <Input
            placeholder={`${tab === 'mail' ? 'Mail' : 'Teléfono'}`}
            searchBarInput={verificationInput}
            handleChange={handleChange}
            type={tab === 'mail' ? 'email' : 'tel'}
          />
        </div>

        <div className='h-10'>
          <SubmitButton text="Reenviar" companyColor={companyColor} dark />
        </div>

        <div className='h-10 mt-2'>
          <Button
            text="Cancelar"
            companyColor={companyColor}
            dark={false}
            onClick={() => {
              handleClose()
              setOrderSent(false)
            }}
          />
        </div>
      </form>

    </Modal>
  )
}

export default NotSentConfirmation
